import * as Yup from 'yup';

export interface ITransferenciaMunicipio {
	chassi: string;
	placa: string;
	tipoConsulta: 'TRANSFERENCIA_MUNICIPIO';
	selecao?: 'chassi' | 'placa';
	documento: string;
	espelho: string;
	categoria?: number | string;
	dataContabil?: string;
	codBanco?: string;
	nsuProdesp?: string;
	restricaoFinanceira?: string;
}

export const initialValues: ITransferenciaMunicipio = {
	chassi: '',
	placa: '',
	documento: '',
	espelho: '',
	tipoConsulta: 'TRANSFERENCIA_MUNICIPIO',
	selecao: 'chassi',
	categoria: '',
	dataContabil: '',
	codBanco: '',
	nsuProdesp: '',
	restricaoFinanceira: 'NADA_CONSTA',
};

export const schema = Yup.object<ITransferenciaMunicipio>().shape({
	placaRenavamChassi: Yup.string().when(['placa', 'chassi'], {
		is: (placa, chassi) => placa === '' && chassi === '',
		then: Yup.string().required(`Campo Obrigatório: Chassi ou Placa.`),
	}),
	documento: Yup.string()
		.required('Campo Obrigatório: CPF/CNPJ Proprietário.')
		.min(11, 'CPF ou CNPJ inválido'),
	categoria: Yup.string().required(`Campo Obrigatório: Categoria.`),
	documentoCategoria: Yup.string().when(['documento', 'categoria'], {
		is: (documento, categoria) =>
			documento.length <= 11 && categoria.toString() === '3',
		then: Yup.string().required(
			'Categoria oficial somente permitido para pessoa jurídica (CNPJ).',
		),
	}),
	espelho: Yup.string().required('Campo Obrigatório: Numero do Espelho.'),
});
